import Paper from 'material-ui/Paper';
import { Component } from 'react';
import './ImageViewer.css';

class ImageViewer extends Component {
  constructor(props, context) {
    super(props, context);
    this.imgViewer = null;
    this.handleCloseImageViewer = this.handleCloseImageViewer.bind(this);
    this.handleImageViewerKeyUp = this.handleImageViewerKeyUp.bind(this);
  }

  handleCloseImageViewer(buttonClicked) {
    this.props.onCloseImageViewer();
  }

  handleImageViewerKeyUp(e) {
    // Pressing the esc key closes the image viewer
    if (e.keyCode === 27) {
      e.preventDefault();
      this.props.onCloseImageViewer();
    }
  }

  componentDidUpdate() {
    // Set the event handler to close the ImageViewer using the ESC key at the window level,
    // so that it works regardless of where the focus is
    if (this.props.imageViewer && this.props.imageViewer.open) {
      window.addEventListener('keyup', this.handleImageViewerKeyUp);
    } else {
      window.removeEventListener('keyup', this.handleImageViewerKeyUp);
    }
  }

  render() {
    let imageViewer = null;

    if (this.props.imageViewer.open) {
      imageViewer = (
        <div
          className="ImageViewerOverlay"
          tabIndex="1"
          onClick={e => {
            this.handleCloseImageViewer(e);
          }}
          onKeyUp={e => {
            this.handleImageViewerKeyUp(e);
          }}
        >
          <Paper
            className="ImageViewerBox"
            ref={imgViewer => {
              this.imgViewer = imgViewer;
            }}
          >
            <img
              src={this.props.imageViewer.imageUrl}
              alt=""
              style={{
                display: 'block',
                maxWidth: '98vw',
                maxHeight: '98vh',
                objectFit: 'scale-down',
              }}
            />
          </Paper>
        </div>
      );
    }

    return imageViewer;
  }
}

export default ImageViewer;
